exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-form-formula-modal .form-formula-modal-sub[data-v-182533ff]{font-size:.75rem;line-height:1rem}", ""]);

// exports
